<template>
  <v-dialog v-model="dialog" persistent width="50%">
    <common-card>
      <CommondLoading
        v-if="loadingModal"
        :loadingImage="dataLoading.inter"
        :show="loadingModal"
        loadingText="Cargando info"
      />
      <v-card-text class="pa-4 black--text" v-else>
        <div
          class="pt-5 pb-5 top-text"
          style="
            width: 100%;
            height: 100%;
            justify-content: center;
            text-align: center;
          "
        >
          {{ idCampaing ? "Edicion" : "Creación" }} de Disposiciones Outbound
          Ventas
        </div>
        <div class="pt-5 pb-5">
          <CreateDispociciones
            :toSave="toSave"
            @goTosave="goTosave"
            @update:toSave="toSave = $event"
            :dispocicionId="idCampaing"
            :dispocicionesData="form"
          />
        </div>
        <div>
          <v-row style="text-align: end">
            <v-col cols="12">
              <v-btn
                text
                color="#00a7e4"
                outlined
                dark
                style="border-radius: 15px"
                @click="$emit('closeModal')"
              >
                Cancelar</v-btn
              >
              <v-btn class="common-botton" dark @click="toSave = true">
                {{ idCampaing ? "Editar" : "Guardar" }}</v-btn
              >
            </v-col>
          </v-row>
        </div>
      </v-card-text>
      <CommonActionModal
        :dialog="dialogEleccion"
        :title="
          idCampaing ? '¿Editar la Disposición?' : '¿Guardar la Disposición?'
        "
        :subtitle="
          idCampaing
            ? '¿Deseas editar esta Dispocicion?'
            : '¿Deseas Guardar esta Dispocicion?'
        "
        :bottonText="idCampaing ? 'Si, editar' : 'Si, guardar'"
        @userChoice="postDispocicion"
      />
    </common-card>
  </v-dialog>
</template>

<script>
import CreateDispociciones from "@/components/commonComponents/forms/CreateDisposicionesOutbound.vue";
import CommonActionModal from "@/components/commonComponents/CommonActionModal.vue";
import CommonCard from "../CommonCard.vue";
import {
  postCrearDispocicion,
  updateDispocicion,
  filtrarDispociciones,
} from "@/services/disposiciones/disposiciones.service";
export default {
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    idCampaing: {
      type: Number,
      default: 0,
    },
  },
  components: {
    CreateDispociciones: CreateDispociciones,
    CommonCard,
    CommonActionModal,
  },
  data() {
    return {
      toSave: false,
      dialogEleccion: false,
      form: {},
      formGuardar: {},
      dispocicionId: this.$route.params.id,
      loadingModal: false,
    };
  },
  methods: {
    async getData() {
      if (!this.idCampaing) return;

      this.loadingModal = true;
      try {
        const { data } = await filtrarDispociciones({ id: this.idCampaing });

        if (data) {
          this.form = Array.isArray(data) ? data[0] : data;
        } else {
          console.error("Invalid data structure:", data);
          this.$toast.error("Error: La campaña no tiene datos válidos.");
        }
      } catch (error) {
        console.error("Error fetching data for idCampaing:", error);
        const toastType = this.getToastType(error);
        const message =
          error.response?.data?.message ||
          error.message ||
          "Error al cargar los datos de la disposición.";
        this.$toast[toastType](message);
      } finally {
        this.loadingModal = false;
      }
    },
    goTosave(valid, form) {
      if (valid) {
        this.formGuardar = form;
      }
      this.dialogEleccion = true;

      this.toSave = false;
    },

    postDispocicion(val) {
      this.dialogEleccion = false;
      if (val) {
        if (!this.idCampaing) this.postCrearDispocicion();
        else this.editCampaniaInboundByID();
      }
    },
    async postCrearDispocicion() {
      const formSend = {
        disposicion: {
          disposicion: this.formGuardar.disposicion.disposicion,
          tipoContacto: this.formGuardar.disposicion.tipo_contacto,
          validador: this.formGuardar.disposicion.validador,
        },
        campania: {
          campaniaId: this.formGuardar.campania.campania_id,
          disposicionId: this.formGuardar.campania.dispocicion_id,
          orden: this.formGuardar.campania.orden,
          status: 1,
          statusLead: this.formGuardar.campania.status_lead,
          tiempoRemarcacion: this.formGuardar.campania.tiempo_remarcacion,
        },
      };

      try {
        await postCrearDispocicion(formSend);
        this.$toast.success("Campaña creada con éxito");
        this.$emit("closeModal");
        this.dialogEleccion = false;
      } catch (error) {
        const msg =
          error.response?.data?.message ||
          error.message ||
          "Ocurrió un error al crear la disposición.";
        const toastType = this.getToastType(error);
        this.$toast[toastType](`Error al crear ${msg}`);
        this.dialogEleccion = false;
      }
    },

    async editCampaniaInboundByID() {
      const formSend = {
        disposicion: {
          disposicion: this.formGuardar.disposicion.disposicion,
          tipoContacto: this.formGuardar.disposicion.tipo_contacto,
          validador: this.formGuardar.disposicion.validador,
        },
        campania: {
          campaniaId: this.formGuardar.campania.campania_id,
          disposicionId: this.formGuardar.campania.disposicion_id,
          orden: this.formGuardar.campania.orden,
          status: this.formGuardar.campania.status,
          statusLead: this.formGuardar.campania.status_lead,
          tiempoRemarcacion: this.formGuardar.campania.tiempo_remarcacion,
          id: this.formGuardar.campania.campania_disposicion_id,
        },
      };

      try {
        await updateDispocicion(formSend, this.dispocicionId);
        this.$toast.success("Campaña editada con éxito");
        this.$emit("closeModal");
        this.dialogEleccion = false;
      } catch (error) {
        const msg =
          error.response?.data?.message ||
          error.message ||
          "Ocurrió un error al crear la disposición.";
        const toastType = this.getToastType(error);
        this.$toast[toastType](msg);
        this.dialogEleccion = false;
      }
    },
    getToastType(error) {
      const status = error?.response?.status;
      return status === 400 ? "warning" : "error";
    },
  },
  mounted() {
    if (this.idCampaing) this.getData();
  },
};
</script>

<style>
.v-toolbar--dense .v-toolbar__content,
.v-toolbar--dense .v-toolbar__extension {
  padding-top: 0;
  padding-bottom: 0;
  justify-content: center;
}

.top-text {
  width: 369px;
  height: 22px;
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 110%;
  display: flex;
  align-items: center;
  text-align: center;
  color: #4d5358;
  flex: none;
  order: 0;
  flex-grow: 1;
}

.confirmation-text {
  /* Por favor, asegúrate de revisar cuidadosamente los cambios antes de continuar */

  width: 369px;
  height: 30px;

  /* Subtitle/S */
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 110%;
  /* or 15px */
  text-align: center;

  color: #555555;

  /* Inside auto layout */
  flex: none;
  order: 2;
  align-self: stretch;
  flex-grow: 0;
}
</style>
